import apiClient from "../../../services/apiClient";
import { TransformFilters } from '../../../utils';
import { QueryKey } from "@tanstack/react-query";
import { Item, TransfersFilter, TransfersRequest, TransfersResponse } from "../types/transfers-response";
import { useCustomToast } from "../../../components";

const { showToast } = useCustomToast();

export const transfersReqAPI = {
  gets: async ({
    queryKey,
  }: {
    queryKey: QueryKey;
  }): Promise<TransfersResponse> => {
    const [, filters] = queryKey as [string, TransfersFilter?];
    const transformedFilters = TransformFilters(filters);
    const response = await apiClient.get('/api/petition/transfer', {
      params: {
        ...transformedFilters,
        paginate: true,
        page: filters?.page,
      },
    });
    return response.data;
  },
  get: async (id: string): Promise<TransfersRequest> => {
    const response = await apiClient.get(`/api/petition/transfer/${id}`);
    return response.data;
  },
  getItems: async (id: string): Promise<Item[]> => {
    const response = await apiClient.get(`/api/petition/transfer/${id}/items`);
    return response.data;
  },
  put: async (
    id: string,
    data: Record<string, TransfersRequest>
  ): Promise<void> => {
    const response = await apiClient.put(`/api/petition/transfer/${id}`, data);
    return response.data;
  },
  post: async (req: TransfersRequest): Promise<void> => {
    const response = await apiClient.post(
      '/api/petition/transfer',
      {
        ...req,
        documents: req?.documents?.map((doc) => doc?.file) || [],
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
  export: async (id: string): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/transfer/documents/${id}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `exportacion_traslado_funcionario.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error: any) {
      throw error;
    }
  },  
  voucher: async (id: string): Promise<void> => {
    try {
      const response = await apiClient.get(`/api/petition/transfer/pdf/${id}`);
      const { url, filename } = response.data;

  
      if (!url) {
        throw new Error('No se encontró la URL del comprobante.');
      }
  
      const fileResponse = await fetch(url);
      const blob = await fileResponse.blob();
  
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename || 'voucher_transfer.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      showToast('success', 'Descarga de comprobante exitosa');
  
    } catch (error) {
      showToast('error', 'Falló descarga de comprobante.');
    }
  },  
  manageItems: async (
  data: Record<string, TransfersRequest>
): Promise<void> => {
  try {
    const response = await apiClient.put(`/api/petition/transfer/manageItems`, data);
    return response.data;
  } catch (error: any) {
    const backendMessage = error?.response?.data?.message || 'Error al gestionar los ítems.';
    showToast('error', backendMessage);
    throw error; // opcional, para que quien llama pueda manejarlo también
  }
},

manage: async (
  id: number,
  data: Record<string, TransfersRequest>
): Promise<void> => {
  try {
    const response = await apiClient.put(`/api/petition/transfer/manage/${id}`, data);
    return response.data;
  } catch (error: any) {
    const backendMessage = error?.response?.data?.message || 'Error al gestionar la solicitud.';
    showToast('error', backendMessage);
    throw error;
  }
},

cancel: async (id: string, data: any): Promise<void> => {
  try {
    const response = await apiClient.patch(`/api/petition/transfer/anulled/${id}`, data);
    return response.data;
  } catch (error: any) {
    const backendMessage = error?.response?.data?.message || 'Error al anular la solicitud.';
    showToast('error', backendMessage);
    throw error;
  }
},
};
